import { GregorioShape } from '../enums/GregorioShape';
import { GregorioType } from '../enums/GregorioType';
import { GregorioGlyph } from '../structures/GregorioGlyph';
import { GregorioNoteElement } from '../structures/GregorioNoteElement';
import { GregorioScore } from '../structures/GregorioScore';
import { GregorioElement, GregorioSyllable } from '../structures/GregorioSyllable';
import { gregorio_note_iter_item_type } from './gregorio_note_iter_item_type';

interface gregorio_note_iter_position {
  score?: GregorioScore;
  syllable?: GregorioSyllable;
  element?: GregorioElement;
  glyph?: GregorioGlyph;
  note?: GregorioNoteElement;
}

interface punctum_inclinatum_vars {
  first: gregorio_note_iter_position;
  previous: gregorio_note_iter_position;
  orientation: GregorioShape;
  running: number;
  count: number;
  unison: boolean;
}

/* data must be (gregorio_shape *) */
function set_shape(p: gregorio_note_iter_position, data: punctum_inclinatum_vars | GregorioShape) {
  p.note!.shape = data as GregorioShape;
}

function set_punctum_inclinatum_orientation(v: punctum_inclinatum_vars) {
  if (v.orientation == GregorioShape.UNDETERMINED) {
    if (v.unison && (v.count > 1 || (v.count == 1 && v.running == 0))) {
      v.orientation = GregorioShape.PUNCTUM_INCLINATUM_STANS;
    } else if (v.running > 0) {
      v.orientation = GregorioShape.PUNCTUM_INCLINATUM_ASCENDENS;
    } else {
      v.orientation = GregorioShape.PUNCTUM_INCLINATUM_DESCENDENS;
    }
  }
}

function finalize_punctum_inclinatum_orientation(v: punctum_inclinatum_vars) {
  if (v.first.note) {
    set_punctum_inclinatum_orientation(v);
    if (v.orientation === GregorioShape.UNDETERMINED) {
      // debugger;
    }
    // gregorio_assert_only(v -> orientation != S_UNDETERMINED,
    //   punctum_inclinatum_orientation_end_item,
    //   "orientation should not be S_UNDETERMINED");
    gregorio_from_note_to_note(v.first, v.previous, true, set_shape,
      undefined, gregorio_note_iter_item_type.GRESTRUCT_NONE, v.orientation);
  }

  // v.first.score = undefined;
  v.first.syllable = undefined;
  v.first.element = undefined;
  v.first.glyph = undefined;
  v.first.note = undefined;
  v.unison = true;
}

/* data must be (punctum_inclinatum_vars *) */
function punctum_inclinatum_orientation_end_item(
  arg1: gregorio_note_iter_position,
  item_type: gregorio_note_iter_item_type,
  data: punctum_inclinatum_vars | GregorioShape,
) {
  const v = data as punctum_inclinatum_vars;

  if (item_type !== gregorio_note_iter_item_type.GRESTRUCT_SYLLABLE) {
    // debugger;
  }

  // gregorio_assert_only(item_type == GRESTRUCT_SYLLABLE,
  //   punctum_inclinatum_orientation_end_item,
  //   "item type should be GRESTRUCT_SYLLABLE");

  finalize_punctum_inclinatum_orientation(v);
  v.count = 0;
}

function gregorio_from_note_to_note(
  start: gregorio_note_iter_position,
  end: gregorio_note_iter_position | undefined,
  include_end: boolean,
  visit: ((p: gregorio_note_iter_position, data: punctum_inclinatum_vars | GregorioShape) => void),
  // eslint-disable-next-line max-len
  end_item: ((arg1: gregorio_note_iter_position, arg2: gregorio_note_iter_item_type, data: punctum_inclinatum_vars | GregorioShape) => void) | undefined,
  desired_end_items: gregorio_note_iter_item_type,
  data: punctum_inclinatum_vars | GregorioShape) {
  /* Note: include_end is effectively ignored if end is NULL */

  const p = start;

  for (let syl_i = 0; syl_i < p.score!.syllables.length; syl_i++) {
    if (!p.element) {
      p.element = p.syllable!.elements[0];
    }
    for (let el_i = 0; el_i < p.syllable!.elements.length; el_i++) {
      if (p.element.type == GregorioType.ELEMENT) {
        if (!p.glyph) {
          p.glyph = p.element.glyphs[0];
        }
        for (let g_i = 0; g_i < p.element.glyphs.length; g_i++) {
          if (p.glyph.type == GregorioType.GLYPH) {
            if (!p.note) {
              p.note = p.glyph.notes.notes[0];
            }
            for (let n_i = 0; n_i < p.glyph.notes.notes.length; n_i++) {
              const at_end = (end && p.note == end.note);

              if (p.note.type == GregorioType.NOTE && (!at_end || include_end)) {
                visit(p, data);
              }

              if (at_end) {
                if (end_item) {
                  if (desired_end_items & gregorio_note_iter_item_type.GRESTRUCT_NOTE) {
                    end_item(p, gregorio_note_iter_item_type.GRESTRUCT_NOTE, data);
                  }
                  if (desired_end_items & gregorio_note_iter_item_type.GRESTRUCT_GLYPH) {
                    end_item(p, gregorio_note_iter_item_type.GRESTRUCT_GLYPH, data);
                  }
                  if (desired_end_items & gregorio_note_iter_item_type.GRESTRUCT_ELEMENT) {
                    end_item(p, gregorio_note_iter_item_type.GRESTRUCT_ELEMENT, data);
                  }
                  if (desired_end_items & gregorio_note_iter_item_type.GRESTRUCT_SYLLABLE) {
                    end_item(p, gregorio_note_iter_item_type.GRESTRUCT_SYLLABLE, data);
                  }
                }
                return;
              }

              if (end_item
                && (desired_end_items & gregorio_note_iter_item_type.GRESTRUCT_NOTE)) {
                end_item(p, gregorio_note_iter_item_type.GRESTRUCT_NOTE, data);

              }
              p.note = p.glyph.notes.notes[n_i + 1];
            } 
          }
          if (end_item && (desired_end_items & gregorio_note_iter_item_type.GRESTRUCT_GLYPH)) {
            end_item(p, gregorio_note_iter_item_type.GRESTRUCT_GLYPH, data);
          }
          p.glyph = p.element.glyphs[g_i + 1];
        } /* glyph */
      }
      if (end_item && (desired_end_items & gregorio_note_iter_item_type.GRESTRUCT_ELEMENT)) {
        end_item(p, gregorio_note_iter_item_type.GRESTRUCT_ELEMENT, data);
      }
      p.element = p.syllable!.elements[el_i + 1];
    } /* element */
    if (end_item && (desired_end_items & gregorio_note_iter_item_type.GRESTRUCT_SYLLABLE)) {
      end_item(p, gregorio_note_iter_item_type.GRESTRUCT_SYLLABLE, data);
    }
    p.syllable = p.score!.syllables[syl_i + 1];
  } /* syllable */
}

function gregorio_for_each_note(score: GregorioScore,
  visit: ((p: gregorio_note_iter_position, data: punctum_inclinatum_vars | GregorioShape) => void),
  // eslint-disable-next-line max-len
  end_item: ((arg1: gregorio_note_iter_position, arg2: gregorio_note_iter_item_type, data: punctum_inclinatum_vars | GregorioShape) => void) | undefined,
  desired_end_items: gregorio_note_iter_item_type, data: punctum_inclinatum_vars) {
  const p: gregorio_note_iter_position = {
    score: score,
    syllable: undefined,
    element: undefined,
    glyph: undefined,
    note: undefined
  };

  p.syllable = p.score!.syllables[0];
  gregorio_from_note_to_note(p, undefined, true, visit, end_item, desired_end_items, data);
}


/* data must be (punctum_inclinatum_vars *) */
function punctum_inclinatum_orientation_visit(
  p: gregorio_note_iter_position, data: punctum_inclinatum_vars | GregorioShape) {
  const shape = p.note!.shape;
  const v = data as punctum_inclinatum_vars;
  if (shape == GregorioShape.PUNCTUM_INCLINATUM_UNDETERMINED) {
    if (v.orientation) {
      p.note!.shape = v.orientation;
    } else {
      /* any cases not covered here will not change running */
      if (v.previous.note
        && (v.first.note || v.previous.syllable == p.syllable)) {
        if (v.previous.note.pitch < p.note!.pitch) {
          ++v.running;
          if (v.count > 0) {
            v.unison = false;
          }
        } else if (v.previous.note.pitch > p.note!.pitch) {
          --v.running;
          if (v.count > 0) {
            v.unison = false;
          }
        }
      }
      if (!v.first.note) {
        v.first.syllable = p.syllable;
        v.first.element = p.element;
        v.first.glyph = p.glyph;
        v.first.note = p.note;
      }
    }
    ++v.count;
  } else { /* non-inclinatum or determined inclinatum */
    let is_punctum_inclinatum = false;

    /* shape can't be S_PUNCTUM_INCLINATUM_UNDETERMINED here */
    switch (shape) {
      case GregorioShape.PUNCTUM_INCLINATUM_ASCENDENS:
        v.orientation = GregorioShape.PUNCTUM_INCLINATUM_ASCENDENS;
        is_punctum_inclinatum = true;
        break;
      case GregorioShape.PUNCTUM_INCLINATUM_STANS:
        v.orientation = GregorioShape.PUNCTUM_INCLINATUM_STANS;
        is_punctum_inclinatum = true;
        break;
      case GregorioShape.PUNCTUM_INCLINATUM_DEMINUTUS:
      case GregorioShape.PUNCTUM_INCLINATUM_AUCTUS:
        v.unison = false;
      /* fall through */
      case GregorioShape.PUNCTUM_INCLINATUM_DESCENDENS:
        v.orientation = GregorioShape.PUNCTUM_INCLINATUM_DESCENDENS;
        is_punctum_inclinatum = true;
        break;
      default:
        is_punctum_inclinatum = false;
        break;
    }

    if (v.first.note) {
      if (!is_punctum_inclinatum) {
        /* if v->first.note is not null,
         * then v->previous.note is not null */
        if (v.previous.note!.pitch < p.note!.pitch && v.previous.syllable == p.syllable) {
          ++v.running;
        } else if (v.previous.note!.pitch > p.note!.pitch) {
          --v.running;
        }
      }
      finalize_punctum_inclinatum_orientation(v);
    }

    if (is_punctum_inclinatum) {
      ++v.count;
      /* and leave orientation alone */
    } else {
      v.running = 0;
      v.count = 0;
      v.orientation = GregorioShape.UNDETERMINED;
    }
  }

  v.previous.syllable = p.syllable;
  v.previous.element = p.element;
  v.previous.glyph = p.glyph;
  v.previous.note = p.note;
}

export function gabc_determine_punctum_inclinatum_orientation(score: GregorioScore) {
  const v: punctum_inclinatum_vars = {
    first: {
      score: score,
      syllable: undefined,
      element: undefined,
      glyph: undefined,
      note: undefined
    },
    previous: {
      score: score,
      syllable: undefined,
      element: undefined,
      glyph: undefined,
      note: undefined
    },
    orientation: GregorioShape.UNDETERMINED,
    running: 0,
    count: 0,
    unison: true
  };

  gregorio_for_each_note(score, punctum_inclinatum_orientation_visit,
    punctum_inclinatum_orientation_end_item, gregorio_note_iter_item_type.GRESTRUCT_SYLLABLE, v);

  if (v.first.note) {
    set_punctum_inclinatum_orientation(v);
    gregorio_from_note_to_note(v.first, v.previous, true, set_shape,
      undefined, gregorio_note_iter_item_type.GRESTRUCT_NONE, v.orientation);
  }
}
